import { render } from "./OnboardingTool.vue?vue&type=template&id=0914c218&scoped=true"
import script from "./OnboardingTool.vue?vue&type=script&lang=js"
export * from "./OnboardingTool.vue?vue&type=script&lang=js"

import "./OnboardingTool.vue?vue&type=style&index=0&id=0914c218&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0914c218"]])

export default __exports__